export default __webpack_public_path__ + "img/spotlightStarBorder.cc8d3a96.svg";